import React, { useEffect, useState } from "react";
import TextField from "@mui/material/TextField";
import {
  Button,
  Container,
  Typography,
  Paper,
  Card,
  CardContent,
  Box,
  InputAdornment,
  Grid,
  Divider,
} from "@mui/material";
import SaveIcon from "@mui/icons-material/Save";
import EmailIcon from "@mui/icons-material/Email";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import DashboardIcon from "@mui/icons-material/Dashboard";
import SettingsIcon from "@mui/icons-material/Settings";
import CancelIcon from "@mui/icons-material/Cancel";
import { useNavigate, useParams } from "react-router-dom";
import ResponsiveDialog from "../../component/dialog/dialog";
import CustomizedBreadcrumbs from "../../component/breadcrumbs/breadcrumbs";
import DrawerPrincipal from "../../component/drawer/drawer-principal";
import { getErrorMessage } from "../../service/api";
import configurationService from "../../service/configurationService";

function InsertConfiguration() {
  const usuario = JSON.parse(localStorage.getItem("user_token")) || {};
  const permission = usuario.roles?.filter((item) => item.name === "Configuração")[0];


  const [idConfiguracao, setIdConfiguracao] = useState();
  const [emailLog, setEmailLog] = useState("");
  const [accountCurrentOmie, setAccountCurrentOmie] = useState("");
  const [superNumberPanelOmie, setSuperNumberPanelOmie] = useState("");
  const [userId, setUserId] = useState("");
  const [createdAt, setCreatedAt] = useState("");
  const [updatedAt, setUpdatedAt] = useState("");


  const [emailLogError, setEmailLogError] = useState("");
  const [accountCurrentOmieError, setAccountCurrentOmieError] = useState("");
  const [superNumberPanelOmieError, setSuperNumberPanelOmieError] = useState("");
  const [userIdError, setUserIdError] = useState("");
  const [createdAtError, setCreatedAtError] = useState("");
  const [updatedAtError, setUpdatedAtError] = useState("");

  const [openDialog, setOpenDialog] = useState();
  const [messageDialog, setMessageDialog] = useState();
  const [titleDialog, setTitleDialog] = useState();
  const [statusDialog, setStatusDialog] = useState();

  const { id } = useParams();

  let navigate = useNavigate();

  useEffect(() => {
    (async () => {
      try {
        const response = await configurationService.editConfiguration(1);
        if (
          response.status === 200 ||
          response.status === 201 ||
          response.success === true
        ) {
          const item = response.data;
          console.log(item);
          setIdConfiguracao(item?.idconfiguration);
          setEmailLog(item?.emailLog);
          setAccountCurrentOmie(item?.accountCurrentOmie);
          setSuperNumberPanelOmie(item?.superNumberPanelOmie);
          setUserId(item?.userId);
          setCreatedAt(item?.createdAt);
          setUpdatedAt(item?.updatedAt);
        } else {
          setOpenDialog(true);
          setStatusDialog("error");
          setTitleDialog("Ops!");
          setMessageDialog(getErrorMessage(response) || "Erro ao buscar Configurações");
        }
      } catch (error) {
        setOpenDialog(true);
        setStatusDialog("error");
        setTitleDialog("Ops!");
        setMessageDialog(getErrorMessage(error) || "Erro ao buscar Configurações");
      }
    })();
  }, [id]);



  const cancel = () => {
    navigate("/configuration");
  };

  async function update() {
    try {
      if (valid()) {
        var data = {
          idconfiguration: idConfiguracao,
          emailLog: emailLog,
          accountCurrentOmie: accountCurrentOmie,
          superNumberPanelOmie: superNumberPanelOmie,
          userId: userId,
          updatedAt: new Date(),
        };

        const response = await configurationService.update(data);

        if (
          response.status === 200 ||
          response.status === 201 ||
          response.success === true
        ) {
          handleDialogOpen();
          setStatusDialog("success");
          setTitleDialog("Muito bem!");
          setMessageDialog(
            response.message || "Configuração atualizado com sucesso"
          );
        } else {
          handleDialogOpen();
          setStatusDialog("error");
          setTitleDialog("Ops");
          setMessageDialog(response.message || "Erro ao atualizar configuração");
        }
      }
    } catch (error) {
      handleDialogOpen();
      setStatusDialog("error");
      setTitleDialog("Ops");
      setMessageDialog(error.message || "Erro ao atualizar configuração");
    }
  }

  function valid() {
    let thatsOk = true;

    if (!emailLog) {
      setEmailLogError("O e-mail de log precisa ser preenchido");
      thatsOk = false;
    }
    if (!accountCurrentOmie) {
      setAccountCurrentOmieError("A conta atual omit precisa ser preenchida");
      thatsOk = false;
    }
    if (!superNumberPanelOmie) {
      setSuperNumberPanelOmieError("O super número do painel omit precisa ser preenchido");
      thatsOk = false;
    }
    return thatsOk;
  }
  const handleDialogOpen = () => {
    setOpenDialog(true);
  };

  const handleDialogClose = () => {
    setOpenDialog(false);
    navigate("/");
  };


  return (
    <>
      <Container maxWidth="lx" sx={{ bgcolor: "#EBEBEB", height: "100vh" }}>
        <DrawerPrincipal
          divOpen={
            <div>
              <div>
                <div className="row mb-3">
                  <CustomizedBreadcrumbs
                    title1={"Home"}
                    link1={"/"}
                    title2={"Configurações"}
                    link2={"#"}
                    title3={"Cadastro de configurações"}
                    link3={"#"}
                  />
                </div>
                <ResponsiveDialog
                  open={openDialog}
                  handleClose={handleDialogClose}
                  title={titleDialog}
                  message={messageDialog}
                  status={statusDialog}
                />

                <Paper
                  sx={{
                    width: "100%",
                    overflow: "hidden",
                    borderRadius: 3,
                    boxShadow: "0 4px 20px rgba(0,0,0,0.08)"
                  }}
                >
                  <Box sx={{ p: 4 }}>
                    <Card
                      sx={{
                        borderRadius: 2,
                        boxShadow: "0 2px 12px rgba(0,0,0,0.05)",
                        background: "linear-gradient(135deg, #f5f7fa 0%, #ffffff 100%)",
                        border: "1px solid rgba(0,0,0,0.05)"
                      }}
                    >
                      <CardContent sx={{ p: 4 }}>
                        <Box sx={{ mb: 3 }}>
                          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                            <SettingsIcon sx={{ fontSize: 40, color: "primary.main" }} />
                            <Typography variant="h4" component="h1" sx={{ fontWeight: 600, color: "text.primary" }}>
                              Configurações Gerais
                            </Typography>
                          </Box>
                        </Box>

                        <Divider sx={{ mb: 4 }} />

                        <Grid container spacing={3}>
                          <Grid item xs={12} md={6}>
                            <TextField
                              fullWidth
                              label="E-mail de Log"
                              variant="outlined"
                              disabled={!permission?.isinsert}
                              value={emailLog || ""}
                              onChange={(e) => {
                                setEmailLog(e.target.value);
                                setEmailLogError("");
                              }}
                              error={!!emailLogError}
                              helperText={emailLogError || "E-mail utilizado para envio de logs do sistema"}
                              InputProps={{
                                startAdornment: (
                                  <InputAdornment position="start">
                                    <EmailIcon sx={{ color: "primary.main" }} />
                                  </InputAdornment>
                                ),
                              }}
                              sx={{
                                "& .MuiOutlinedInput-root": {
                                  "&:hover fieldset": {
                                    borderColor: "primary.main",
                                  },
                                },
                              }}
                            />
                          </Grid>

                          <Grid item xs={12} md={6}>
                            <TextField
                              fullWidth
                              label="Conta Corrente para envio OMIE"
                              variant="outlined"
                              disabled={!permission?.isinsert}
                              value={accountCurrentOmie || ""}
                              onChange={(e) => {
                                setAccountCurrentOmie(e.target.value);
                                setAccountCurrentOmieError("");
                              }}
                              error={!!accountCurrentOmieError}
                              helperText={accountCurrentOmieError || "Conta Corrente para envio OMIE"}
                              InputProps={{
                                startAdornment: (
                                  <InputAdornment position="start">
                                    <AccountCircleIcon sx={{ color: "primary.main" }} />
                                  </InputAdornment>
                                ),
                              }}
                              sx={{
                                "& .MuiOutlinedInput-root": {
                                  "&:hover fieldset": {
                                    borderColor: "primary.main",
                                  },
                                },
                              }}
                            />
                          </Grid>

                          <Grid item xs={12} md={6}>
                            <TextField
                              fullWidth
                              label="Número painel Pai"
                              variant="outlined"
                              disabled={!permission?.isinsert}
                              value={superNumberPanelOmie || ""}
                              onChange={(e) => {
                                setSuperNumberPanelOmie(e.target.value);
                                setSuperNumberPanelOmieError("");
                              }}
                              error={!!superNumberPanelOmieError}
                              helperText={superNumberPanelOmieError || "Número do Painel pai para envio OMIE"}
                              InputProps={{
                                startAdornment: (
                                  <InputAdornment position="start">
                                    <DashboardIcon sx={{ color: "primary.main" }} />
                                  </InputAdornment>
                                ),
                              }}
                              sx={{
                                "& .MuiOutlinedInput-root": {
                                  "&:hover fieldset": {
                                    borderColor: "primary.main",
                                  },
                                },
                              }}
                            />
                          </Grid>
                        </Grid>
                      </CardContent>
                    </Card>

                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "flex-end",
                        gap: 2,
                        mt: 4,
                        pt: 3,
                        borderTop: "1px solid rgba(0,0,0,0.1)",
                      }}
                    >
                      <Button
                        variant="outlined"
                        color="error"
                        onClick={cancel}
                        startIcon={<CancelIcon />}
                        sx={{
                          px: 3,
                          py: 1.5,
                          textTransform: "none",
                          fontSize: "1rem",
                          fontWeight: 500,
                        }}
                      >
                        Cancelar
                      </Button>
                      {permission?.isinsert && (
                        <Button
                          variant="contained"
                          onClick={update}
                          startIcon={<SaveIcon />}
                          sx={{
                            px: 4,
                            py: 1.5,
                            textTransform: "none",
                            backgroundColor: "#000000",
                            fontSize: "1rem",
                            fontWeight: 500,
                            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.3)",
                            "&:hover": {
                              boxShadow: "0 6px 16px rgba(0, 0, 0, 0.4)",
                            },
                          }}
                        >
                          Salvar Configurações
                        </Button>
                      )}
                    </Box>
                  </Box>
                </Paper>
              </div>
            </div>
          }
        />
      </Container>
    </>
  );
}
export default InsertConfiguration;
